exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".purple-wipe{text-align:center;background:linear-gradient(90deg,#3023ae 20%,#c96dd8 40%,#c96dd8 60%,#3023ae 80%);background-size:200% auto;color:#000;background-clip:text;text-fill-color:transparent;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation:shine 10s linear infinite}@-webkit-keyframes shine{to{background-position:200%}}@keyframes shine{to{background-position:200%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?modules&localIdentName=[name]---[local]---[hash:base64:5]!./client/styles/logo.styl
// module id = 385
// module chunks = 0